import React, { useState } from 'react';
import { arrayOf, shape, string, func, node } from 'prop-types';
import { noop } from 'lodash';
import cn from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { Button, Icon } from '@fiverr-private/fit';
import { l_chevron_right } from '@fiverr-private/icons';
import classes from './index.module.scss';

const BriefFrame = ({
    steps,
    onSubmit = noop,
    submitButtonLabel,
    className,
}) => {
    const [step, setStep] = useState(0);

    const onBack = () => {
        const { onBack = noop } = steps[step];
        onBack();
        setStep(step - 1);
    };

    const onNext = () => {
        const { onNext = noop } = steps[step];
        onNext();
        setStep(step + 1);
    };

    const { formContent, sideContent, canProceed = () => true } = steps[step];

    return (
        <div className={cn(classes.stepContentWrapper, className)}>
            <div className={classes.stepContent}>
                {steps.length > 1 && (
                    <div className={classes.stepCounter}>
                        <I18n k="variations_display.marketplace.step" />{' '}
                        {step + 1}/{steps.length}
                    </div>
                )}
                <h4 className={classes.title}>
                    <I18n k="variations_display.marketplace_listing.brief.title" />
                </h4>
                <div className={classes.subtitle}>
                    <I18n k="variations_display.marketplace_listing.brief.subtitle" />
                </div>
                {formContent}
                <div className={classes.buttonsWrapper}>
                    {step > 0 && (
                        <button
                            className={cn(classes.backButton, classes.button)}
                            onClick={() => onBack()}
                        >
                            <I18n k="variations_display.general.back" />
                        </button>
                    )}
                    {step === steps.length - 1 ? (
                        <Button
                            className={classes.button}
                            disabled={!canProceed()}
                            onClick={onSubmit}
                        >
                            {submitButtonLabel}
                            <Icon className={classes.icon} color="white">
                                {l_chevron_right}
                            </Icon>
                        </Button>
                    ) : (
                        <Button
                            className={classes.button}
                            disabled={!canProceed()}
                            onClick={() => onNext()}
                        >
                            <I18n k="variations_display.general.next" />
                            <Icon className={classes.icon} color="white">
                                {l_chevron_right}
                            </Icon>
                        </Button>
                    )}
                </div>
            </div>
            <div className={classes.briefImage}>{sideContent}</div>
        </div>
    );
};

BriefFrame.propTypes = {
    steps: arrayOf(
        shape({
            formContent: node,
            sideContent: node,
            onBack: func,
            onNext: func,
            canProceed: func,
        })
    ),
    onSubmit: func,
    submitButtonLabel: string,
    className: string,
};

export default BriefFrame;
